import { produce } from 'immer';
import { getTracker } from '../tracker';

const initialState = {
  tabs: [],
  selectedTab: '',
  sizeOptions: [],
  unitTypeOptions: [],
  selectedSize: {},
  selectedUnit: '',
  tableData: undefined,
  data: undefined,
  selectedTabIndex: 0,
  isLoading: false,
  acceptAll: false,
  acceptedItems: [],
  comments: {},
  showCommentsDialog: false,
};

function getTableData(data) {
  let tabs = [];
  let sizeOptions = {};
  let unitTypeOptions = {};
  let tableData = {};
  let totalAccepted = {};
  let kpi = {};
  data.forEach((elem) => {
    if (tabs.indexOf(elem.Store) === -1) tabs.push(elem.Store);

    if (!tableData[elem.Store]) {
      tableData[elem.Store] = { data: [] };
      tableData[elem.Store].data.push(elem);

      unitTypeOptions[elem.Store] = {};
      sizeOptions[elem.Store] = {};
      totalAccepted[elem.Store] = {};
      kpi[elem.Store] = {};
    } else tableData[elem.Store].data.push(elem);

    if (!unitTypeOptions[elem.Store][elem.UnitType]) {
      unitTypeOptions[elem.Store][elem.UnitType] = 1;
      kpi[elem.Store][elem.UnitType] = {
        beekin: elem.RecommendPrice / elem.UnitSize,
        rentplus: elem.PreviousEffectivePrice / elem.UnitSize,
      };
    } else {
      unitTypeOptions[elem.Store][elem.UnitType]++;
      kpi[elem.Store][elem.UnitType].beekin +=
        elem.RecommendPrice / (elem.UnitSize * elem.UnitSize);
      kpi[elem.Store][elem.UnitType].rentplus +=
        elem.PreviousEffectivePrice / (elem.UnitSize * elem.UnitSize);
    }

    if (!sizeOptions[elem.Store][elem.UnitSize])
      sizeOptions[elem.Store][elem.UnitSize] = 1;
    else sizeOptions[elem.Store][elem.UnitSize]++;
  });

  tabs.sort();

  let unitOptions = {};
  let any = { text: 'Any', value: 'Any' };
  let selectedSize = {};
  Object.keys(unitTypeOptions).forEach((Store) => {
    unitOptions[Store] = Object.keys(unitTypeOptions[Store]).map((type) => {
      return { text: type, value: type, key: Store + type };
    });
    // sizeOpts[Store] = Object.keys(sizeOptions[Store]).map(size => {
    //     return { text: size, value: size };
    // })
    tableData[Store].unitOptions = unitOptions[Store];
    tableData[Store].unitOptions.splice(0, 0, {
      ...any,
      key: Store + 'unitany',
    });
    let obj = { Any: [] };

    tableData[Store].data.forEach((elem) => {
      if (
        obj[elem.UnitType] &&
        obj[elem.UnitType].indexOf(elem.UnitSize) === -1
      ) {
        obj[elem.UnitType].push(elem.UnitSize);
      } else {
        obj[elem.UnitType] = [];
        obj[elem.UnitType].push(elem.UnitSize);
      }
      if (obj.Any.indexOf(elem.UnitSize) === -1) obj.Any.push(elem.UnitSize);
    });
    selectedSize[Store] = {};
    Object.keys(obj).forEach((type) => {
      obj[type] = obj[type].map((size) => {
        return { text: size, value: size, key: Store + size };
      });
      obj[type].splice(0, 0, { ...any, key: Store + 'typeany' });
      selectedSize[Store][type] = '';
    });
    tableData[Store].sizeOptions = obj;
    tableData[Store].totalAccepted = totalAccepted[Store];
    let anyAccepted = 0;
    tableData[Store].accepted = {};
    tableData[Store].unitOptions.forEach((elem) => {
      let obj = {};
      anyAccepted +=
        elem.text !== 'Any' ? tableData[Store].totalAccepted[elem.text] : 0;
      tableData[Store].accepted[elem.text] = false;
      if (
        tableData[Store].totalAccepted[elem.text] ===
        tableData[Store].sizeOptions[elem.text].length - 1
      )
        tableData[Store].accepted[elem.text] = true;
      return obj;
    });
    if (anyAccepted === tableData[Store].data.length) {
      tableData[Store].accepted['Any'] = true;
    }
  });

  return { tableData, tabs, selectedSize, kpi };
}

const updateAcceted = (tableData, Store) => {
  let total = 0;
  Object.keys(tableData[Store].totalAccepted).forEach((value) => {
    total += tableData[Store].totalAccepted[value];
  });
  if (total === tableData[Store].data.length) {
    tableData[Store].accepted.Any = true;
  } else tableData[Store].accepted.Any = false;
  return tableData;
};

function getModeledKpi(data) {
  let kpis = { chartData: {}, kpi: {} };
  data.chartData.forEach((d) => {
    if (!kpis.chartData[d.Store]) kpis.chartData[d.Store] = {};
    if (kpis.chartData[d.Store]) {
      if (!kpis.chartData[d.Store][d.UnitType])
        kpis.chartData[d.Store][d.UnitType] = [d];
      else kpis.chartData[d.Store][d.UnitType].push(d);
    }
  });
  data.kpis.forEach((d) => {
    if (!kpis.kpi[d.Store]) kpis.kpi[d.Store] = {};
    if (kpis.kpi[d.Store]) {
      if (!kpis.kpi[d.Store][d.UnitType]) kpis.kpi[d.Store][d.UnitType] = d;
      // kpis.kpi[d.Store][d.UnitType].push(d);
    }
  });
  return kpis;
}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'IS_LOADING': {
      return Object.assign({}, state, { isLoading: true });
    }
    case 'IS_NOT_LOADING': {
      return Object.assign({}, state, { isLoading: false });
    }
    case 'FETCH_DATA_SUCCESS': {
      if (action.payload.priceCards.length > 0) {
        let { tableData, tabs, selectedSize } = getTableData(
          action.payload.priceCards
        );
        let kpis = getModeledKpi(action.payload.kpi);
        let { selectedTab, selectedUnit } = state;
        let tab = localStorage.getItem('selectedStore');
        selectedTab = tab && tabs.includes(tab) ? tab : tabs[0];

        selectedUnit = tableData[selectedTab].unitOptions[0].value; // unitTypeOptions[selectedTab][0].value;
        selectedSize[selectedTab][selectedUnit] =
          tableData[selectedTab].sizeOptions[selectedUnit][0].value; // sizeOptions[selectedTab][0].value;
        return {
          ...state,
          data: action.payload,
          isLoading: false,
          tableData,
          tabs,
          selectedSize,
          selectedTab,
          selectedUnit,
          selectedTabIndex: tabs.indexOf(selectedTab),
          kpiData: kpis, // { aws: action.payload.kpi, calculated: kpi, modeledKpi: undefined }
        };
      } else {
        return {
          ...state,
          data: action.payload,
          isLoading: false,
        };
      }
    }
    case 'UPDATE_SELECTED_UNIT': {
      return produce(state, (draft) => {
        getTracker().track(action.type, { selectedUnit: action.payload });

        const { selectedTab, tableData } = draft;
        const newSelectedUnit = action.payload;

        if (!draft.selectedSize[selectedTab]) {
          draft.selectedSize[selectedTab] = {};
        }
        if (!draft.selectedSize[selectedTab][newSelectedUnit]) {
          draft.selectedSize[selectedTab][newSelectedUnit] =
            tableData[selectedTab].sizeOptions[newSelectedUnit][0].value;
        }

        draft.selectedUnit = newSelectedUnit;
      });
    }

    case 'UPDATE_SELECTED_SIZE': {
      return produce(state, (draft) => {
        getTracker().track(action.type, { selectedSize: action.payload });

        const { selectedTab, selectedUnit } = draft;

        if (!draft.selectedSize[selectedTab]) {
          draft.selectedSize[selectedTab] = {};
        }
        draft.selectedSize[selectedTab][selectedUnit] = action.payload;
      });
    }

    case 'UPDATE_SELECTED_TAB': {
      return produce(state, (draft) => {
        getTracker().track(action.type, { selectedTab: action.payload });

        const { tableData } = draft;
        const selectedTab = action.payload;

        draft.selectedUnit = tableData[selectedTab].unitOptions[0].value;

        if (!draft.selectedSize[selectedTab]) {
          draft.selectedSize[selectedTab] = {};
        }
        if (!draft.selectedSize[selectedTab][draft.selectedUnit]) {
          draft.selectedSize[selectedTab][draft.selectedUnit] =
            tableData[selectedTab].sizeOptions[draft.selectedUnit][0].value;
        }

        localStorage.setItem('selectedStore', selectedTab);

        draft.selectedTab = selectedTab;
        draft.selectedTabIndex = draft.tabs.findIndex((e) => e === selectedTab);
      });
    }
    case 'UPDATE_STATUS': {
      let { tableData, selectedTab } = state;
      if (
        action.payload.status === 'approved' ||
        action.payload.status === 'declared'
      ) {
        tableData[selectedTab].totalAccepted[action.payload.item.UnitType]++;
      } else
        tableData[selectedTab].totalAccepted[action.payload.item.UnitType]--;

      let index = tableData[selectedTab].data.indexOf(action.payload.item);
      if (index !== -1)
        tableData[selectedTab].data[index].status = action.payload.status;

      let { Store } = action.payload.item;
      tableData = updateAcceted(tableData, Store);

      return Object.assign({}, state, {
        tableData: Object.assign({}, tableData),
      });
    }
    case 'UPDATE_STATUS_ALL': {
      let { Store, UnitType, status } = action.payload;
      let { tableData } = state;
      if (status === 'approved') {
        if (UnitType !== 'Any') {
          tableData[Store].accepted[UnitType] = true;
          tableData[Store].totalAccepted[UnitType] =
            tableData[Store].sizeOptions[UnitType].length - 1;
          tableData[Store].data.forEach((elem) => {
            if (elem.UnitType === UnitType) elem.status = status;
          });
        } else {
          Object.keys(tableData[Store].totalAccepted).forEach((value) => {
            tableData[Store].totalAccepted[value] =
              tableData[Store].sizeOptions[value].length - 1;
            tableData[Store].accepted[value] = true;
          });
          tableData[Store].data.forEach((elem) => (elem.status = status));
        }
      } else {
        if (UnitType !== 'Any') {
          tableData[Store].accepted[UnitType] = false;
          tableData[Store].data.forEach((elem) => {
            if (elem.UnitType === UnitType) elem.status = status;
          });
          tableData[Store].totalAccepted[UnitType] = 0;
        } else {
          Object.keys(tableData[Store].totalAccepted).forEach((value) => {
            tableData[Store].totalAccepted[value] = 0;
            tableData[Store].accepted[value] = false;
          });
          tableData[Store].data.forEach((elem) => (elem.status = status));
        }
      }
      tableData = updateAcceted(tableData, Store);

      return Object.assign({}, state, {
        tableData: Object.assign({}, tableData),
        isLoading: false,
      });
    }

    case 'UPDATE_PRICE': {
      const { item, newPrice, comments, override } = action.payload;
      getTracker().track(action.type, action.payload);

      return produce(state, (draft) => {
        if (!draft.tableData || !draft.tableData[item.Store]) return;

        const storeData = draft.tableData[item.Store]?.data;

        for (let i = 0; i < storeData.length; i++) {
          if (parseInt(storeData[i].id) === parseInt(item.id)) {
            storeData[i].UpdatedPrice = newPrice;
            storeData[i].Price = newPrice;
            storeData[i].IsUpdated = true;
            storeData[i].comments = comments;

            if (override) {
              const { user, overrideDays } = action.payload;
              const overriddenDate = new Date();
              overriddenDate.setDate(overriddenDate.getDate() + overrideDays);

              storeData[i].IsOverridden = true;
              storeData[i].OverriddenOn = new Date();
              storeData[i].OverriddenBy = user;
              storeData[i].OverrideDays = overrideDays;
            } else {
              storeData[i].IsOverridden = false;
            }
            break;
          }
        }

        draft.isLoading = false;
      });
    }

    case 'ADD_COMMENT': {
      let tableData = Object.assign({}, state.tableData);
      let [row] = tableData[action.payload.store].data.filter(
        (e) => e.id === action.payload.priceId
      );
      row && row.totalcomments++;
      return Object.assign({}, state, { tableData });
    }
    case 'NOTIFICATION_TYPE': {
      let tableData = Object.assign({}, state.tableData);
      let { Type, data, Store } = action.payload;
      switch (Type) {
        case 'price_override': {
          let [row] = tableData[Store].data.filter(
            (e) => e.id === '' + data.PriceId
          );
          if (row) {
            row.IsOverridden = true;
            row.OverriddenBy = data.override.CreatedBy;
            row.OverriddenOn = data.override.CreatedOn;
            row.Price = data.override.OverriddenPrice;
            row.UpdatedPrice = data.override.OverriddenPrice;
            row.IsUpdated = true;
          }
          break;
        }
        case 'price_update': {
          let [row] = tableData[Store].data.filter(
            (e) => e.id === '' + data.PriceId
          );
          if (row) {
            row.IsOverridden = false;
            row.Price = data.NewPrice;
            row.UpdatedPrice = data.NewPrice;
            row.IsUpdated = true;
          }
          break;
        }
        case 'comment': {
          let [row] = tableData[Store].data.filter(
            (e) => e.id === '' + data.PriceId
          );
          if (row) {
            row.totalcomments++;
          }
          break;
        }
        case 'alert': {
          break;
        }
        default: {
          break;
        }
      }
      return Object.assign({}, state, {
        tableData: Object.assign({}, tableData),
      });
    }
    case 'FREEZE_PRICE': {
      let { tableData } = state;
      let data = tableData[action.payload.store].data.map((elem) => {
        return {
          ...elem,
          Price: elem.PreviousEffectivePrice,
          UpdatedPrice: elem.PreviousEffectivePrice,
          IsUpdated: true,
        };
      });
      tableData[action.payload.store] = Object.assign(
        {},
        tableData[action.payload.store],
        { data }
      );
      return Object.assign({}, state, {
        tableData: Object.assign({}, tableData),
      });
    }
    case 'LOGOUT': {
      return initialState;
    }

    default: {
      return state;
    }
  }
};
export default dashboardReducer;
